import React from "react";
import AboutPage from "../Components/About/AboutPage";
import Footer from "../Components/Footer/Footer";
import Header from "../Components/Header/Navbar"

const About : React.FC= () => {
  return (
    <>
    <Header/>
      <AboutPage />
      <Footer/>
    </>
  );
};

export default About;
